import { urbnrest } from '../../rest/urbnrest';

/**
 * Client class for Profile Service interaction for authorization
 */
export default class ProfileClient {
    /**
     * Create a new instance for the ProfileClient
     * @param  {[String]} siteId  A15 profile site ID
     * @param  {[String]} baseURL Base URL of the ProfileService to use
     * @return {[ProfileClient]}  a new instance of ProfileClient
     */
	constructor(siteId, baseURL) {
		this._siteId = siteId;
		this._baseURL = `${baseURL}/${siteId}`;
        this._client = urbnrest({ prefix: this._baseURL });
	}

    /**
     * Get the A15 site ID being used
     * @return {[String]} the A15 site ID
     */
	get siteId() {
		return this._siteId;
	}

    /**
     * Create a new profile
     *
     * @param  {String} emailAddress     the new profile's email address
     * @param  {String} password         the new profile's password
     * @param  {String} confirmPassword  the new profile's password confirmation
     * @param  {Object} otherProfileData additional data fields for the new profile
     * @param  {Object} headers          any HTTP headers you want to specify
     * @return {Promise}                 resolves and rejects with a rest.js HTTP response
     */
	createProfile(emailAddress, password, confirmPassword, otherProfileData, headers = {}) {
        const body = Object.assign({}, otherProfileData, {
            'emailAddress': emailAddress,
            'password': password,
            'confirmPassword': confirmPassword
        });

        return this._client({
            method: 'POST',
            path: '/profiles',
            headers: headers,
            entity: body
        });
	}

    /**
     * Start forgot password flow for a profile
     *
     * @param  {String} emailAddress the profile's email address
     * @param  {Object} headers any HTTP headers you want to specify
     * @return {Promise}             resolves and rejects with a rest.js HTTP response
     */
    forgotPassword(emailAddress, headers = {}) {
        const body = {
            'username': emailAddress
        };

        return this._client({
            method: 'POST',
            path: '/credentials/password',
            headers: headers,
            entity: body
        });
    }
}
